export default __webpack_public_path__ + "static/media/Series-8200-MP-Insertion-Remote.fe93e837.png";